import { Fragment } from 'react';

import useOmeEntryLoading from './UseOmeEntryLoading';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const OmeEntryLoading = ({ teamRedirectNavLink, athleteRedirectNavLink }) => {
  const {
    isLoading
  } = useOmeEntryLoading(teamRedirectNavLink, athleteRedirectNavLink);

  return (
    <Fragment>
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default OmeEntryLoading;